import { useTranslation } from 'react-i18next'

import type { AmountLimits } from '@/services/lineItems/productConstraints'
import { formatMoney } from '../utils/money'

function money(amount: number, currency?: string): string {
  return formatMoney(amount, currency, 2)
}

/**
 * Formats a booked product's price limits as label text — "Min 5.00 NOK",
 * "Fixed by the product" — for the `hint` of a `FieldLabel`.
 */
export function useFieldLimitText() {
  const { t } = useTranslation()

  return function limitText(limits?: AmountLimits, currency?: string): string | undefined {
    if (!limits) return undefined

    const parts: string[] = []
    if (limits.fixed && limits.min != null) {
      parts.push(t('lineItems.limitFixed', { value: money(limits.min, currency) }))
    } else if (limits.min != null) {
      parts.push(t('lineItems.limitMin', { value: money(limits.min, currency) }))
    }
    if (limits.max != null) {
      parts.push(t('lineItems.limitMax', { value: money(limits.max, currency) }))
    }
    return parts.length ? parts.join(' · ') : undefined
  }
}
